<mat-toolbar class="toolbar">
  <div class="toolbar-trailing">
    <payarc-theme-toggle class="toolbar-theme-toggle" [compact]="true"></payarc-theme-toggle>

    <div class="loader loader--style8" title="loading" *ngIf="!currentAccountName && menuName == 'Home'">
      <img src="../../../assets/images/uploading.svg">
    </div>

    <button type="button" class="toolbar-account-trigger unselectable" *ngIf="currentAccountName"
            [matMenuTriggerFor]="accountMenu" aria-haspopup="true">
      <span class="toolbar-account-trigger__name">{{activeUser.dba_name || currentAccountName}}</span>
      <svg class="toolbar-account-trigger__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    </button>
    <mat-menu #accountMenu="matMenu" class="pa-topbar-account-panel" xPosition="before">
      <div class="pa-menu-header" (click)="$event.stopPropagation()">
        <div class="pa-menu-header__name">{{activeUser.dba_name || currentAccountName}}</div>
        <div class="pa-menu-header__sub">{{currentAccountName}}</div>
        <div class="pa-menu-header__mid" *ngIf="activeUser.mid">{{activeUser.mid}}</div>
      </div>
      <div class="pa-menu-filter-wrap" (click)="$event.stopPropagation()">
        <svg class="pa-menu-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>
        </svg>
        <input class="pa-menu-filter" #myInput placeholder="Filter by name" [(ngModel)]="name"
               (focus)="name = null"
               (keydown)="$event.key !== 'Escape' && $event.stopPropagation()">
      </div>
      <div class="pa-menu-scroll">
        <ng-container *ngFor="let account of currentUsers | search:'account_name,mid,dba_name':name; trackBy: trackByAccountId">
          <button mat-menu-item class="acct-row" (click)="switchAccount(account.id, account.account_name)"
                  [class.activeAccount]="account.id === currentAccountId">
            <span class="acct-name">{{account.dba_name ? account.dba_name + ' - ' : ''}}{{account.account_name ? account.account_name : account.id}}</span>
            <span class="acct-mid" *ngIf="account.mid">{{account.mid}}</span>
          </button>
        </ng-container>
      </div>
    </mat-menu>

    <button type="button" class="toolbar-profile-trigger unselectable" *ngIf="userName" [matMenuTriggerFor]="profileMenu"
            aria-haspopup="true" aria-label="Open profile menu">
      <span class="toolbar-profile__avatar" aria-hidden="true">{{userNameIcon | camalizeStr}}</span>
    </button>
    <mat-menu #profileMenu="matMenu" class="pa-topbar-profile-panel" xPosition="before">
      <div class="pa-menu-header" (click)="$event.stopPropagation()">
        <div class="pa-menu-header__name">{{(userName || '') | camalizeStr}}</div>
        <div class="pa-menu-header__email">{{userEmail}}</div>
      </div>
      <div class="pa-menu-theme" (click)="$event.stopPropagation()">
        <span class="pa-menu-section-label">Theme</span>
        <payarc-theme-toggle></payarc-theme-toggle>
      </div>
      <div class="pa-menu-divider"></div>
      <button mat-menu-item class="pa-menu-item-icon" (click)="myprofile()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-6 8-6s8 2 8 6"/>
        </svg>
        Profile
      </button>
      <button mat-menu-item class="pa-menu-item-icon" (click)="toUpdateContact()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/>
        </svg>
        Contact
      </button>
      <button mat-menu-item class="pa-menu-item-icon pa-menu-signout" (click)="signOut()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        Signout
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
